import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRightIcon } from 'lucide-react';
const HERO_BG = 'https://cdn.magicpatterns.com/patterns/generated-images/17131631-7be5-416f-8772-3861a99947e8.jpg';
const fadeUp = {
  hidden: {
    opacity: 0,
    y: 24
  },
  show: (i: number) => ({
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.6,
      delay: i * 0.1,
      ease: [0.22, 1, 0.36, 1] as const
    }
  })
};
export function Hero() {
  return <section id="top" className="relative w-full overflow-hidden bg-ink-950 text-white" data-id="element-84" data-mp="128z14h6wu40r">
      <img src={HERO_BG} alt="" aria-hidden="true" className="absolute inset-0 h-full w-full object-cover opacity-60" data-id="element-85" data-mp="xbp8yts4ze98" />
      <div className="absolute inset-0 bg-gradient-to-b from-ink-950/60 via-ink-950/70 to-ink-950" data-id="element-86" data-mp="ncgiwc0e6js5" />

      <div className="relative mx-auto flex max-w-container flex-col items-start px-6 pb-28 pt-40 lg:px-8 lg:pb-36 lg:pt-52" data-id="element-87" data-mp="3d21rlvg2wgmo">
        <motion.span custom={0} variants={fadeUp} initial="hidden" animate="show" className="mb-6 inline-flex items-center gap-2 rounded-full border border-gold-500/40 bg-gold-500/10 px-4 py-1.5 text-xs font-semibold uppercase tracking-[0.2em] text-gold-400" data-id="element-88" data-mp="381e6fqej6u0d">
          Maximizing Education Solutions
        </motion.span>

        <motion.h1 custom={1} variants={fadeUp} initial="hidden" animate="show" className="max-w-4xl font-display text-4xl font-semibold leading-[1.05] tracking-tight sm:text-5xl lg:text-7xl" data-id="element-89" data-mp="3e8mur4n88xh9">
          Growth systems for the leaders shaping education.
        </motion.h1>

        <motion.p custom={2} variants={fadeUp} initial="hidden" animate="show" className="mt-6 max-w-2xl text-lg leading-relaxed text-white/70 lg:text-xl" data-id="element-90" data-mp="2qlepuntpnqfr">
          We partner with forward-thinking education founders and CEOs to increase
          revenue by $500K–$1M in 12 months — through sharper messaging, automated
          marketing systems, and sales that convert.
        </motion.p>

        <motion.div custom={3} variants={fadeUp} initial="hidden" animate="show" className="mt-10 flex flex-col gap-4 sm:flex-row sm:items-center" data-id="element-91" data-mp="nat8heoiaqma">
          <a href="https://calendly.com/jmctagency/disco" target="_blank" rel="noreferrer" className="group inline-flex items-center justify-center gap-2 rounded-full bg-gold-500 px-7 py-4 text-sm font-semibold text-ink-950 transition-colors hover:bg-gold-400" data-id="element-92" data-mp="ddww2xvhlkcg">
            Book a strategy call
            <ArrowRightIcon className="h-4 w-4 transition-transform group-hover:translate-x-0.5" data-id="element-93" data-mp="114svag29vhtq" />
          </a>
          <a href="#approach" className="inline-flex items-center justify-center rounded-full border border-white/20 px-7 py-4 text-sm font-semibold text-white transition-colors hover:bg-white/5" data-id="element-94" data-mp="3lsyt309hwojl">
            See how we work
          </a>
        </motion.div>

        <motion.div custom={4} variants={fadeUp} initial="hidden" animate="show" className="mt-16 grid w-full grid-cols-2 gap-8 border-t border-white/10 pt-10 sm:max-w-2xl sm:grid-cols-3" data-id="element-95" data-mp="1x7hvvdunc30v">
          {[{
          stat: '$500K–$1M',
          label: 'Revenue added in 12 months'
        }, {
          stat: '2–3 mo',
          label: 'To first measurable lift'
        }, {
          stat: '2×',
          label: 'Average conversion rate'
        }].map(item => <div key={item.label} data-id="element-96" data-mp="2l0qab1ft1wri">
              <div className="font-display text-2xl font-semibold text-gold-400 lg:text-3xl" data-id="element-97" data-mp="2ozz60bueo4pp">
                {item.stat}
              </div>
              <div className="mt-1 text-sm text-white/60" data-id="element-98" data-mp="2tysic0xyhpoa">{item.label}</div>
            </div>)}
        </motion.div>
      </div>
    </section>;
}